import { Controller } from '@hotwired/stimulus';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default class extends Controller {
  connect() {
    this.tooltips = [];
    this.initializeTooltips();
    document.addEventListener('turbo:frame-load', this.handleFrameLoad);
  }

  disconnect() {
    this.tooltips.forEach((tooltip) => {
      tooltip.destroy();
    });
    this.tooltips = [];
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad);
  }

  handleFrameLoad = (event) => {
    if (this.element.contains(event.target)) {
      this.initializeTooltips();
    }
  };

  initializeTooltips() {
    const elements = this.element.querySelectorAll('[data-tip]');

    elements.forEach((element) => {
      if (!element._tippy) {
        const tooltip = tippy(element, {
          content: element.getAttribute('data-tip'),
          placement: 'top',
          arrow: true,
        });

        this.tooltips.push(tooltip);
      }
    });
  }
}
